import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { repiLimits } from '../../../store/repiStore';
import { hasPermission } from '../../../store/apiWrapper';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import HistoryLink from '../../common/historyLink';
import HorizontalScrollControl from '../../layoutItems/horizontalScrollControl';
import RepiContactHistorySection from './contactHistory/repiContactHistorySection';

import '../repi.scss';

class ContactHistory extends React.Component {
    colorizeRow = true;

    state = {
        historyExpanded: false,
        showAllAddresses: false
    };

    render() {
        if (isNullOrUndefined(this.props.data))
            return null;

        const { data } = this.props;
        return (
            <div className="repi-contacts-data">
                {this.renderContactHistory(data)}
                {this.renderIdentificationHistory(data)}
                {this.renderAddressHistory(data)}
                {this.renderContactHistoryTeaser(data)}
            </div>
        );
    }

    renderContactHistory = (data) => {
        if (!hasPermission(null, "REPIContacts"))
            return null;

        return (
            <>
                {data.hasHistoricalContacts && <div className="repi-history-button">
                    <span onClick={this.toggleHistory} className="link-functional link-orange link-left print-hidden">
                        <HistoryLink noWrapper historyExpanded={this.state.historyExpanded} />
                    </span>
                </div>}
                {(data.phoneNumbersCount > 0 || data.emailsCount > 0 || data.ipAddressesCount > 0) &&
                    <HorizontalScrollControl leftArrowMargin="0em">
                        <table width="100%">
                            <colgroup>
                                <col width="15%" />
                                <col width="20%" />
                                <col width="20%" />
                                <col width="20%" />
                                <col width="25%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td className="align-right"><Translate id="Repi.Report.Contacts.ReportedDate" /></td>
                                    <td className="align-right"><Translate id="Repi.Report.Contacts.CrossReference" /></td>
                                    <td className="align-right">
                                        <Translate id="Repi.Report.Contacts.UniqueDataForLastDays" data={{ days: data.contactMaxAge }} />
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {data.phoneNumbersCount > 0 && <RepiContactHistorySection label="Repi.Report.Contacts.Phone" isPhone
                                    data={data.phoneNumbers} count={data.maxAgePhoneNumbersCount} historyExpanded={this.state.historyExpanded} />}
                                {data.emailsCount > 0 && <RepiContactHistorySection label="Repi.Report.Contacts.Email" colorize
                                    data={data.emails} count={data.maxAgeEmailsCount} historyExpanded={this.state.historyExpanded} />}
                                {data.ipAddressesCount > 0 && <RepiContactHistorySection label="Repi.Report.Contacts.IpAddress"
                                    data={data.ipAddresses} count={data.maxAgeIpAddressesCount} historyExpanded={this.state.historyExpanded} />}
                            </tbody>
                        </table>
                    </HorizontalScrollControl>}
            </>
        );
    }

    renderIdentificationHistory = (data) => {
        if (isNullOrUndefined(data.identificationHistory) || !data.identificationHistory.hasData)
            return null;

        this.colorizeRow = true;

        const hasContactHistory = hasPermission(null, "REPIContacts") && (data.phoneNumbersCount > 0 || data.emailsCount > 0 || data.ipAddressesCount > 0);

        return (
            <>
                <div className="repi-subsection-header" style={hasContactHistory ? { marginTop: "1.5em" } : { marginTop: "0.5em" }}>
                    <Translate id="Repi.Report.IdentificationHistory" />
                </div>
                <table width="100%">
                    <tbody>
                        {this.renderIdentificationHistoryRow(data.identificationHistory.names, "Names")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.surnames, "Surnames")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.birthDates, "BirthDates")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.pins, "Pins")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.aliases, "Aliases")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.companyNames, "CompanyNames")}
                        {this.renderIdentificationHistoryRow(data.identificationHistory.companyIds, "CompanyIds")}
                    </tbody>
                </table>
            </>
        );
    }

    renderAddressHistory = (data) => {
        if (data.addressesCount > 0 && (isNullOrUndefined(data.addressHistory) || data.addressHistory.length === 0))
            return null;

        const hasIdentificationHistory = !(isNullOrUndefined(data.identificationHistory) || !data.identificationHistory.hasData);
        const limited = !this.state.showAllAddresses && data.addressHistory.length > repiLimits.contactHistoryAddresses;
        const toShow = limited ? data.addressHistory.slice(0, repiLimits.contactHistoryAddresses) : data.addressHistory;

        return (
            <>
                <div className="repi-subsection-header" style={ hasIdentificationHistory ? { marginTop: "1.5em" } : undefined}>
                    <Translate id="Repi.DataCorrection.Email.Addresses.Header" />
                </div>
                <table width="100%">
                    <colgroup>
                        <col width="60%" />
                        <col width="25%" />
                        <col width="15%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <td><Translate id="Repi.Report.Address" /></td>
                            <td className="align-right"><Translate id="Repi.Report.Contacts.ReportedDate" /></td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {toShow.map((a, i) => <tr key={i} className={classnames("contact-row", { "row-color": i % 2 === 1 })}>
                            <td>{this.formatAddress(a)}</td>
                            <td className="align-right">{a.dataEndDateFormatted}</td>
                            <td className="align-right">{a.verifiedInCribis ? this.props.translate("Repi.Report.Contacts.Verified") : ""}</td>
                        </tr>)}
                        {data.addressHistory.length > repiLimits.contactHistoryAddresses && <tr>
                            <td>
                                <span className="link-functional print-hidden" onClick={() => this.setState({ showAllAddresses: !this.state.showAllAddresses })}>
                                    <Translate id={this.state.showAllAddresses ? "Report.Hide" : "Report.Common.ShowAll"} />
                                </span>
                            </td>
                        </tr>}
                    </tbody>
                </table>
            </>
        );
    }

    renderContactHistoryTeaser = (data) => {
        if (hasPermission(null, "REPIContacts"))
            return null;

        const hasIdentificationHistory = !(isNullOrUndefined(data.identificationHistory) || !data.identificationHistory.hasData);
        const hasAddressHistory = data.addressesCount > 0;

        return (
            <div style={ hasAddressHistory || hasIdentificationHistory ? { marginTop: "1.5em" } : undefined}>
                <div className="repi-contacts-header"><Translate id="Repi.Report.Contacts.UniqueDataForLastDays" data={{ days: data.contactMaxAge }} /></div>
                <div className="repi-contacts-line-under-header"></div>
                <div className="repi-contacts-numbers-table-container">
                    <table width="100%" border="0">
                        <tbody>
                            <tr>
                                <td width="33%">
                                    <div>{data.maxAgePhoneNumbersCount}</div>
                                    <div><Translate id="Repi.Report.Contacts.Counts.PhoneNumbers" /></div>
                                </td>
                                <td width="33%">
                                    <div>{data.maxAgeEmailsCount}</div>
                                    <div><Translate id="Repi.Report.Contacts.Counts.Emails" /></div>
                                </td>
                                <td width="33%">
                                    <div>{data.maxAgeIpAddressesCount}</div>
                                    <div><Translate id="Repi.Report.Contacts.Counts.IPAddresses" /></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderIdentificationHistoryRow = (data, trKey) => {
        if (isNullOrUndefined(data) || data === "")
            return null;

        this.colorizeRow = !this.colorizeRow;

        return (
            <tr className={classnames("contact-row", { "row-color": this.colorizeRow })}>
                <td>
                    <span className="bold"><Translate id={`Repi.Report.IdentificationHistory.${trKey}`} />:</span>
                    {` ${data}`}
                </td>
            </tr>
        );
    }

    formatAddress = (a) => {
        let ret = `${a.street || ""} ${a.houseNo || ""}, ${a.city || ""}, ${a.zip || ""}`.replace(" ,", "");
        return ret.trim() === "" ? "" : `${ret}, ${a.country}`;
    }

    toggleHistory = () => this.setState({ historyExpanded: !this.state.historyExpanded });
}

export default connect(
    state => state.userContext,
    null
)(withLocalize(withRouter(ContactHistory)));
